import internalChatChannelsAPI from 'dashboard/api/internalChatChannels';

// keyed by channelId → array of user objects currently typing
const state = {
  typing: {},
};

const getters = {
  getUserList: s => channelId => s.typing[channelId] || [],
};

const mutations = {
  ADD_USER(s, { channelId, user }) {
    const existing = s.typing[channelId] || [];
    if (existing.find(u => u.id === user.id)) return;
    s.typing = { ...s.typing, [channelId]: [...existing, user] };
  },
  REMOVE_USER(s, { channelId, userId }) {
    const existing = s.typing[channelId] || [];
    s.typing = {
      ...s.typing,
      [channelId]: existing.filter(u => u.id !== userId),
    };
  },
};

const actions = {
  create({ commit }, { channelId, user }) {
    commit('ADD_USER', { channelId, user });
    internalChatChannelsAPI
      .toggleTypingStatus(channelId, 'on')
      .catch(() => {});
  },

  destroy({ commit }, { channelId, userId }) {
    commit('REMOVE_USER', { channelId, userId });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
